<template>
  <div id="lost-view">
    <h1>Page Not Found</h1>
  </div>
</template>

<script>
export default {
  name: 'lost',
};
</script>



// WEBPACK FOOTER //
// src/views/Lost.vue